import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

export function DynamicPageForFuture({ message }) {
  return (
    <ContentWrap>
      {message ? (
        <div dangerouslySetInnerHTML={{ __html: message }} />
      ) : (
        <>
          <h3>We're sorry, this promotion is not available yet.</h3>
          <p>More great deals are available <a href="/">here</a>.</p>
        </>
      )}
    </ContentWrap>
  );
}

export default (props) => <ComponentErrorBoundary><DynamicPageForFuture {...props} /></ComponentErrorBoundary>;
